export default "__VITE_ASSET__DYzvzWQC__"